module.exports = __webpack_public_path__ + "static/media/arrow-down.74c7e1cc.svg";